import { render, staticRenderFns } from "./ShiftDisplay.vue?vue&type=template&id=2d55a169&scoped=true&"
import script from "./ShiftDisplay.vue?vue&type=script&lang=js&"
export * from "./ShiftDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ShiftDisplay.vue?vue&type=style&index=0&id=2d55a169&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55a169",
  null
  
)

export default component.exports